module.exports = __webpack_public_path__ + "media/images/pc/articles/popular_contents_guide-0cc6c00deac1da5edd9a84e3ca2322c2.webp";